import React, { FC, useState } from 'react'
import { Grid, Typography } from '@mui/material'

import UserSelect from './UserSelect'
import UserChart from './UserChart'
import Title from '../Title'

const SingleUser: FC = () => {
  const [selectedUser, setSelectedUser] = useState<string>('')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSelectedUser(event.target.value)
  }

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" mb={2} color="secondary">
          User info
        </Typography>
        <UserSelect selectedUser={selectedUser} handleSelect={handleChange} />
      </Grid>
      <Grid item xs={12}>
        {selectedUser ? (
          <>
            <UserChart selectedUser={selectedUser} apiPath="getScheduledExperiments" type="sdmt" label="SDMT" />
            <UserChart selectedUser={selectedUser} apiPath="getScheduledExperiments" type="walking" label="2MWT" />
            <UserChart selectedUser={selectedUser} apiPath="getScheduledObservations" type="pro" label="Questions" />
          </>
        ) : (
          <Title>Select user to show data</Title>
        )}
      </Grid>
    </>
  )
}
export default SingleUser
